module.exports = __webpack_public_path__ + "static/img/img3.fed1c66.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/slideVerify/assets/img3.jpg
// module id = Akql
// module chunks = 1